module.exports = __webpack_public_path__ + "SC05_Guest.6ed55245.png";